import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { makeComponentSelector } from "@client/selectors/components";
import { type AppState, type WithId } from "@client/types";
import { EMPTY_ARRAY } from "@common/lib/array";
import Component, { type MapProps } from "./component";

type Props = WithId & {
  gid: string;
  style?: React.CSSProperties;
};

const makeMapStateToProps = () => {
  const componentSelector = makeComponentSelector();

  return (state: AppState, { gid, ...props }: Props): MapProps & WithIsVisibleHOCProps => {
    const component = componentSelector(state, { gid });
    if (!component) {
      return {
        id: "",
        componentEntityId: "",
        componentId: "",
        isVisible: false,
        itemIds: EMPTY_ARRAY,
        name: ""
      };
    }

    const entity = Object.values(component.entities).find((x) => !x.parentId)!;

    return {
      id: props.id,
      componentEntityId: entity.id,
      componentId: component.id,
      isVisible: true,
      itemIds: entity.childrenIds,
      name: component.name
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
